import React from 'react';

import ProductsSlider from 'Component/ProductsSlider';
import { PROMO_WITHIN_PRODUCTS_SLIDER_SETTINGS } from 'Component/ProductsSlider/ProductsSlider.config';
import CategoryPagination from 'SourceComponent/CategoryPagination';
import ProductCard from 'SourceComponent/ProductCard';
import { ProductList as SourceProductList } from 'SourceComponent/ProductList/ProductList.component';
import ProductListPage from 'SourceComponent/ProductListPage';
import { GRID_LAYOUT } from 'SourceRoute/CategoryPage/CategoryPage.config';

import './ProductList.override.style';

/** @namespace AdvoxBasic/Component/ProductList/Component/ProductList */
export class ProductList extends SourceProductList {
    productListRef = React.createRef();

    componentDidUpdate(prevProps) {
        const { isWidget, currentPage } = this.props;
        const { currentPage: prevCurrentPage } = prevProps;

        // Scroll up on page change, ignore widgets
        if (prevCurrentPage !== currentPage && !isWidget) {
            setTimeout(() => {
                this.scrollToProductList();
            }, 0);
        }

        const { isInfiniteLoaderEnabled } = this.props;

        if (isInfiniteLoaderEnabled) {
            this.observePageChange();
        }
    }

    scrollToProductList() {
        if (this.productListRef.current) {
            this.productListRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    renderPagination() {
        const { isLoading, totalPages, requestPage, isPaginationEnabled } = this.props;

        if (!isPaginationEnabled) {
            return null;
        }

        return <CategoryPagination isLoading={isLoading} totalPages={totalPages} onPageSelect={requestPage} />;
    }

    renderPage(props = {}) {
        const {
            isInfiniteLoaderEnabled,
            loadPage,
            isLoading,
            isVisible,
            currentPage,
            mix,
            isSlider,
            isPromoList,
            isDailyPromoWithinSlider,
            title,
        } = this.props;
        const { items, keys, pageNumber, selectedFilters, wrapperRef } = this._processProps(props);

        if (!isLoading && isPromoList) {
            return items.map((product, i) => (
                <ProductCard
                    product={product}
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    layout={GRID_LAYOUT}
                />
            ));
        }

        if (isDailyPromoWithinSlider) {
            return (
                <section block="ProductsSections" key={title}>
                    <ProductsSlider
                        items={items}
                        heading={title}
                        isLoading={isLoading}
                        settings={PROMO_WITHIN_PRODUCTS_SLIDER_SETTINGS}
                    />
                </section>
            );
        }

        if (isSlider) {
            return (
                <section block="ProductsSections" key={title}>
                    <ProductsSlider items={items} heading={title} isLoading={isLoading} />
                </section>
            );
        }

        return (
            <ProductListPage
                key={currentPage + Math.random()}
                isInfiniteLoaderEnabled={isInfiniteLoaderEnabled}
                updatePages={loadPage}
                isLoading={isLoading}
                isVisible={isVisible}
                mix={mix}
                items={items}
                keys={keys}
                pageNumber={pageNumber}
                selectedFilters={selectedFilters}
                wrapperRef={wrapperRef}
                isPromoList={isPromoList}
            />
        );
    }

    renderNoProducts() {
        return (
            <div block="ProductList">
                <div block="ProductList" elem="ProductsMissing">
                    <h2>{__('We are sorry!')}</h2>
                    <h3>
                        <span>{__('There were no products found')}</span> {__('matching your request.')}
                    </h3>
                    <p>{__('Please, try removing selected filters and try again!')}</p>
                </div>
            </div>
        );
    }

    render() {
        const { totalPages, isLoading, mix, isSlider, isPromoList, renderOnlyPagination } = this.props;

        if (isSlider || isPromoList) {
            return this.renderPages();
        }

        if (!isLoading && totalPages === 0) {
            return this.renderNoProducts();
        }

        if (renderOnlyPagination) {
            return <>{this.renderPagination()}</>;
        }

        return (
            <div block="ProductList" mods={{ isLoading }} mix={mix} ref={this.productListRef}>
                {this.renderTitle()}
                {this.renderLoadButton()}
                {this.renderPages()}
                {this.renderPagination()}
            </div>
        );
    }
}

export default ProductList;
